import { htmlSafe } from '@ember/template';
import { helper as buildHelper } from '@ember/component/helper';
export default buildHelper(function (value) {
  const min = Math.ceil(value[0] || 0),
    max = Math.floor(value[1] || 1);

  return htmlSafe(Math.floor(Math.random() * (max - min + 1)) + min);
});
